import React from 'react';
import './MensajeVistaCcUo.css';


const MensajeMantenedor = () => {
  return (
    <>
      <div className="container_mensajes_mantenedor">
         <spam>Descripción: </spam><spam className="txt_descripcion">En está sección podrás buscar un contrato y asignarle un centro de costo y unidad organizacional. </spam>
      </div>

    </>
  )
}
export default MensajeMantenedor;